import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import { IntlProvider } from "react-intl";
import { ConfigProvider, LocaleProvider } from "antd";

import App from "./App";
import { UserProvider } from "./context/context";
import en_US from "./locale/en_US";
import zh_CN from "./locale/zh_CN";
import antdEn from "antd/lib/locale-provider/en_US";
import antdZh from "antd/lib/locale-provider/zh_CN";

function selectMessage(lang) {
  switch (lang) {
    case "en":
      return { antd: antdEn, locale: en_US };
    case "zh":
      return { antd: antdZh, locale: zh_CN };
    default:
      return { antd: antdZh, locale: zh_CN };
  }
}

const locale = "en";

ReactDOM.render(
  <ConfigProvider autoInsertSpaceInButton={false}>
    <IntlProvider locale={locale} messages={selectMessage(locale).locale}>
      <LocaleProvider locale={selectMessage(locale).antd}>
        <UserProvider>
          <Router>
            <App />
          </Router>
        </UserProvider>
      </LocaleProvider>
    </IntlProvider>
  </ConfigProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
